export enum SHARED_STORAGE_LOADING_STATE {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
